import React from 'react';
import Main from './Main';
import FirebaseContext from './firebase/firebaseContext';
import Firebase from './firebase/firebase';

function App() {
  return (
    <FirebaseContext.Provider value={ new Firebase()}>
      <Main/>
    </FirebaseContext.Provider>
  );
}

export default App;
